import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * TableResultsView class extends JetView to create a data table view.
 */
export default class TableResultsView extends JetView {
    /**
     * Configures the data table layout and properties.
     * @returns {Object} Configuration object for the data table.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type as a datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            id: 'tableResponts', // Unique identifier for the datatable
            select: true, // Enables row selection
            columns: [
                // Defines the columns of the datatable
                { id: 'Nro', header: _('Nro'), width: 100, sort: 'int' }, // Column for number with sorting
                { id: 'User', header: _('Usuario'), width: 200, sort: 'int' }, // Column for user with sorting
                {
                    id: 'Score',
                    header: _('Puntuación'), // Column for score with sorting
                    width: 100,
                    sort: 'int',
                },
            ],
            math: true, // Enables mathematical operations on the datatable
            loadahead: devConfig.getDefaultDataFetch(), // Sets the data fetch strategy
            pager: 'pagerA', // Identifier for the pager component
            url: devConfig.geturlApi() + 'Leagues/GetResults', // API endpoint for fetching data
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Retrieves the URL for data loading
        this.on(this.app, 'resultsTable:id', (item) => {
            // Event listener for loading data based on item ID
            grid.clearAll(); // Clears existing data in the grid
            grid.load(url + '?id=' + item.id); // Loads new data based on the selected item ID
        });
    }
}

// FILE DOCUMENTED
